import React, { useState, useRef } from "react";
import "./ContactDetails.css";
import "../JobDetailsPage/JobApplyForm.css";
// import { MapPin } from "lucide-react";
import { baseURl } from "../../config";
import ReCAPTCHA from "react-google-recaptcha";
import {
  FaUser,
  FaComment,
  FaBuilding,
  FaEnvelope,
  FaPhoneAlt,
} from "react-icons/fa";
import { useSelector } from "react-redux";
import { decodeHtml } from "../util";

const ContactDetails = () => {
  const { page } = useSelector((state) => state.data);
  const rawHtml1 = page.data["contact-details"]?.htmlContent || "";
  const htmlContent = decodeHtml(rawHtml1);

  const [recaptchaToken, setRecaptchaToken] = useState(null);
  const recaptchaRef = useRef(null);
  const [formData, setFormData] = useState({
    fullName: "",
    company: "",
    email: "",
    phoneNumber: "",
    message: "",
  });

  const [successMessage, setSuccessMessage] = useState("");

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!recaptchaToken) {
      alert("Please complete the CAPTCHA");
      return;
    }

    try {
      const response = await fetch(`${baseURl}/api/v1/form`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ ...formData, recaptchaToken }), // Include the reCAPTCHA token
      });

      const result = await response.json();
      if (response.ok) {
        setSuccessMessage("Form submitted successfully!");
        setFormData({
          fullName: "",
          company: "",
          email: "",
          phoneNumber: "",
          message: "",
        });
        setRecaptchaToken(null);
        recaptchaRef.current?.reset();

        window.scrollTo({ top: 0, behavior: "smooth" });

        setTimeout(() => {
          setSuccessMessage("");
        }, 3000);
      } else {
        setSuccessMessage(`Error: ${result.message}`);
      }
    } catch (error) {
      console.error("Error submitting form:", error);
      setSuccessMessage("An error occurred. Please try again.");
    }
  };

  return (
    <section className="contact-details-section">
      <div></div>
      <div className="contact-details-heading">
        <h3>CONTACT US</h3>
      </div>
      <div className="contactus-container">
        <div className="contact-us-form">
          <h2>Get in Touch</h2>
          {successMessage && (
            <div
              className="success-message"
              style={{
                backgroundColor: "#FF3E00",
                color: "white",
                padding: "10px",
                textAlign: "center",
                borderRadius: "5px",
              }}
            >
              {successMessage}
            </div>
          )}
          <div className="unique-job-apply-form">
            <form onSubmit={handleSubmit}>
              <label htmlFor="contact-name">
                <FaUser /> Full Name:
              </label>
              <input
                type="text"
                id="contact-name"
                name="fullName"
                value={formData.fullName}
                onChange={handleChange}
                required
              />

              <label htmlFor="contact-company">
                <FaBuilding /> Company Name:
              </label>
              <input
                type="text"
                id="contact-company"
                name="company"
                value={formData.company}
                onChange={handleChange}
                required
              />

              <label htmlFor="contact-email">
                <FaEnvelope /> Email Address:
              </label>
              <input
                type="email"
                id="contact-email"
                name="email"
                value={formData.email}
                onChange={handleChange}
                required
              />

              <label htmlFor="contact-phone">
                <FaPhoneAlt /> Phone Number:
              </label>
              <input
                type="tel"
                id="contact-phone"
                name="phoneNumber"
                value={formData.phoneNumber}
                onChange={(e) => {
                  const value = e.target.value.replace(/[^0-9+\-]/g, "");
                  if (value.replace(/\D/g, "").length > 18) return; // Allow only numbers, +, and -
                  handleChange({ target: { name: "phoneNumber", value } });
                }}
                pattern="[\d+\-]+"
                inputMode="tel"
                required
              />

              <label htmlFor="message">
                <FaComment /> Message:
              </label>
              <textarea
                className="contact-form-message"
                id="message"
                name="message"
                value={formData.message}
                onChange={handleChange}
                required
              />

              <div className="captcha">
                <ReCAPTCHA
                  // sitekey="6LcjWAgrAAAAAFYpQO9XlP-jq-39EU2UHmJsgrLA"
                  sitekey="6LeVeMMrAAAAALdmEHCly_TpKSetClpg7gA1yDzI"
                  onChange={(token) => setRecaptchaToken(token)}
                />
              </div>

              <div className="submit-container">
                <button type="submit">Submit</button>
              </div>
            </form>
          </div>
        </div>

        <div className="contact-details-container">
          <div className="contactus-description">
            <p>
              At the heart of our mission is a steadfast commitment to
              delivering exceptional quality, unmatched precision, and
              unwavering reliability, ensuring that industries worldwide receive
              superior solutions tailored to their unique needs and challenges.
            </p>
          </div>

          {htmlContent && (
            <div
              className="extraP"
              dangerouslySetInnerHTML={{ __html: htmlContent }}
            />
          )}
        </div>
      </div>
    </section>
  );
};

export default ContactDetails;
